module.exports = __webpack_public_path__ + "static/img/step2.fb101f54.png";